export const statuses = ["scheduled", "open", "completed", "assigned"];
export const sizes = ["sm", "md", "lg"];
